import "./App.css";
import Home from "./pages/Home/Index";

function App() {
  return (
    <div className="App">
      <Home></Home>
    </div>
  );
}

export default App;
